import { useState } from "react";
import { toast } from "sonner";
import { OctagonXIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ActionDialog } from "@/components/emc/ActionDialog";
import { announceHaltChange, haltSending } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

// The API's note limit (`SendingHaltIn`).
const NOTE_MAX = 300;

/** The platform-wide stop (F1): every pool and campaign, behind a dialog that
 * asks why. Admin only — the API refuses anybody else. Lifting it is the red
 * bar's, in the shell. The warmup page shows it in its header ("Teljes
 * leállítás"); the sidebar's footer shows the same control, smaller. */
export function HaltButton({
  halted,
  compact = false,
  className,
}: {
  halted: boolean;
  compact?: boolean;
  className?: string;
}) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (user?.role !== "admin" || halted) return null;
  return (
    <>
      <Button
        variant="outline-danger"
        size={compact ? "sm" : "default"}
        type="button"
        className={cn(compact && "h-7 px-2.5 text-label", className)}
        title="Vészfék: minden pool és kampány egy percen belül megáll; feloldás indoklással"
        onClick={() => setOpen(true)}
      >
        {!compact && <OctagonXIcon />}
        {compact ? "Leállítás" : "Teljes leállítás"}
      </Button>
      <ActionDialog
        open={open}
        onOpenChange={setOpen}
        title="Teljes leállítás"
        description={
          <>
            Minden pool és minden kampány megáll; a workerek legfeljebb egy percen belül veszik
            észre. A poolok saját állapota nem változik: ez egy kapcsoló fölöttük. Feloldani a piros
            sávon lehet, szintén indoklással.
          </>
        }
        confirmLabel="Kiküldés leállítása"
        tone="danger"
        reason={{ label: "Miért állítod le?", placeholder: "pl. rossz lista ment ki", max: NOTE_MAX }}
        onConfirm={async (note) => {
          await haltSending(note);
          announceHaltChange();
          toast("A kiküldés leállt.");
        }}
      />
    </>
  );
}
